import {ApolloLink} from '@apollo/client';
import {BatchHttpLink} from '@apollo/client/link/batch-http';
import fetch from 'isomorphic-fetch';

import {getClientHeaders} from 'ClientHeaders';
import {isBrowser} from 'lib/Browser';

// Allow overriding the fetch function we use - typically we'll use the global fetch, but in contexts like
// exports, we override network requests to control server/client communication.
let fetchFn: WindowOrWorkerGlobalScope['fetch'] | undefined;

export function setFetchFn(newFetch: WindowOrWorkerGlobalScope['fetch'] | undefined): void {
  fetchFn = newFetch;
}

export function resetFetchFnForTests(): void {
  fetchFn = undefined;
}

export function createSingleBatchLink(
  options: Pick<BatchHttpLink.Options, 'batchInterval' | 'batchMax'>
): ApolloLink {
  return new BatchHttpLink({
    uri: '/graphql',
    includeExtensions: true,
    fetch: (input: RequestInfo, init?: RequestInit) => (fetchFn || fetch)(input, init),
    headers: isBrowser ? getClientHeaders() : undefined,
    ...options,
  });
}
